(function () {
    'use strict';

    angular.module('app.core').animation('.ng-slide', function () {
        return {
            enter: function (element, done) {
                element.slideDown('fast', function () {
                    done();
                });
            },

            leave: function (element, done) {
                element.slideUp('fast', function () {
                    done();
                });
            },

            //this is called BEFORE the class is added
            beforeAddClass: function (element, className, done) {
                if (className == 'ng-hide') {
                    element.slideUp('fast', function () {
                        done();
                    });
                }
            },

            //this is called BEFORE the class is removed
            beforeRemoveClass: function (element, className, done) {
                if (className == 'ng-hide') {
                    element.slideDown('fast', function () {
                        done();
                    });
                }
            }
        };
    });
})();